import { Viewer } from "@xeokit/xeokit-sdk";

const initializeViewer = async (viewerRef, setEntityData, setPopoverPosition, setAnchorEl) => {
  console.log("Initializing viewer...");
  if (viewerRef.current) {
    console.log("Viewer already initialized.");
    return viewerRef.current;
}
    const viewer = new Viewer({
      canvasId: "myViewerCanvas",
      transparent: true,
      edges: true,
      saoEnabled: true, // improves the realism of the rendered scene
    });
    viewerRef.current = viewer;

  
    // Example camera control
    viewer.camera.eye = [250, 180, 300];
    viewer.camera.look = [60, 80, 0]; // Center of the model
    viewer.camera.up = [0, 1, 0]; // Up direction

    const camera = viewer.scene.camera;

    const pivotElement = document.createRange().createContextualFragment("<div class='xeokit-camera-pivot-marker'></div>").firstChild;
    document.body.appendChild(pivotElement); // Append the pivot marker to the document
    viewer.cameraControl.pivotElement = pivotElement;

    return viewer;
};

export default initializeViewer;